import React, { Component } from 'react';
import CheckboxSection from "./CheckboxSection";
import ConfiguracionContraseniaDetallada from "./ConfiguracionContraseniaDetallada";

const ConfiguracionContrasenia = (props) => {
    return (
        <div className="">
            <div className="divisor-section">
                <h3>Configuración de contraseña</h3>
            </div>
            <div>
                <h5 className="configuration-view-subtitle">La contraseña debe solicitar...</h5>
            </div>
            <div className="">
                <CheckboxSection message="Caracteres alfabéticos"
                    isChecked={props.alfabetica}
                    checkboxChangeState={props.checkboxChangeState}
                    identifier="alfabetica"
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message="Caracteres numéricos"
                    isChecked={props.numerica}
                    identifier="numerica"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message="Caracteres especiales"
                    isChecked={props.caracteresEspeciales}
                    identifier="caracteresEspeciales"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message="Caracteres en mayuscúlas y en minuscúlas"
                    className="box"
                    isChecked={props.caseSensitive}
                    identifier="caseSensitive"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>
            </div>
            <div>
                <h5 className="configuration-view-subtitle">y debe validar que...</h5>
            </div>
            <div className="">
                <CheckboxSection message="La cantidad mínima de caracteres para la contraseña sea de: "
                    isChecked={props.caracteresMinimos != null}
                    identifier="caracteresMinimos"
                    checkboxChangeState={props.checkboxChangeState}
                    value={props.caracteresMinimos}
                    extencion=" caracteres"
                    textChangeState={props.textChangeState}/>

                <CheckboxSection message="No permita la repetición de un mismo caracter"
                    subMessage=" "
                    isChecked={props.permiteCaracteresIguales}
                    identifier="permiteCaracteresIguales"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>

                {(props.permiteCaracteresIguales && props.permiteCaracteresIguales == true) ?
                    (<ConfiguracionContraseniaDetallada permiteCaracteresIguales={props.permiteCaracteresIguales}
                        permiteLetrasConsecutivas={props.permiteLetrasConsecutivas}
                        permiteNrosConsecutivos={props.permiteNrosConsecutivos}
                        permiteRepetirPosicion={props.permiteRepetirPosicion}
                        radioButtonChangeContrasenia={props.radioButtonChangeContrasenia}/>) :
                    (null)}

                <CheckboxSection message="No permita el mismo caracter en la misma posición en la contraseña actual y en la próxima contraseña"
                    isChecked={props.permiteRepetirPosicion}
                    identifier="permiteRepetirPosicion"
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}/>
            </div>

        </div>
    );
};

export default ConfiguracionContrasenia;


